
































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbMember } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
@Component({
    components: {
    },
})
export default class payResultPanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:'确定'
    })
    btnTxt:String;
    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        default:true
    })
    result:Boolean;
    @Prop({
        default:false
    })
    isShowQueryBot:Boolean;
    @Prop({
        type:Object,
        default:()=>{
            return{

            }
        }
    })
    orderInfo:any;

    @Prop({
        default:""
    })
    errorCode:String;
    @Prop({
        default:''
    })
    errorMessage:String;
    @Prop({
        default:''
    })
    payMethodChangeMsg:String;



    fmoney = fmoney;


    created() {

    }

    mounted() {

    }

    /**支付方式名称 */
    get payName(){
        let str = "";
        switch (this.orderInfo.paymentMethod) {
            case 1:
                str = "会员卡"
                break;
            case 2:
                str = "现金支付"
                break;
            case 3:
                str = "微信"
                break;
            case 4:
                str = "支付宝"
                break;
            case 13:
                str = "线下微信"
                break;
            case 14:
                str = "线下支付宝"
                break;

            default:
                if((this.orderInfo.paymentMethod>4&&this.orderInfo.paymentMethod<12)||this.orderInfo.paymentMethod>14){
                    str = "组合支付"
                }
                break;
        }
        return str;
    }

    confimrFun(){
        this.$emit("confimrFun");
    }
    closeFun(){
        this.$emit("closeFun");
    }
    viewDetail(){
        this.$emit("closeFun");
        this.$router.push(`/pad/report/index?tag=order&curZL=3&id=${this.orderInfo.id}&orderStatus=0`)
    }
    rePay(){
        this.$emit("closeFun");
        this.$emit('rePay');
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/payResultPanel.vue